import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import Container from 'components/ui/Container';
import PrimaryButton from 'components/ui/PrimaryButton';
import useToggle from 'hooks/useToggle';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ITrainingInput, useDeleteTrainingMutation } from 'redux/reducers/training';

import TrainingManagementTable from './TrainingManagementTable';
import Modal from 'components/ui/Modal/modal';
import SecondaryButton from 'components/ui/SecondaryButton';
import ResourcesList from './ResourcesList';

const TrainingManagement = () => {
  const timerRef = React.useRef<NodeJS.Timeout>();
  const [selectedData, setSelectedData] = useState<any>();

  const navigate = useNavigate();
  const [deleteModal, toggleDeleteModal] = useToggle(false);
  const [showResourceModal, toggleResourceModal] = useToggle(false);

  const [showQuery, setShowQuery] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const [deletingTrainingState, setDeletingTraining] = useState<ITrainingInput | null>(null);

  const [deleteTraining, { isLoading: isDeleting }] = useDeleteTrainingMutation();

  const onEditClicked = (data: ITrainingInput) => {
    navigate(`/training-mgmt/training/edit/${data.id}`);
    //${data.id}
  };

  const onDeleteConfirm = () => {
    deletingTrainingState &&
      deleteTraining(deletingTrainingState?.id)
        .unwrap()
        .then((data: any) => {
          toast.success('Deleted Successfully');
          toggleDeleteModal();
        })
        .catch((err: any) => {
          toast.error('Error');
        });
  };

  const onDeleteClicked = (data: ITrainingInput) => {
    setDeletingTraining(data);
    toggleDeleteModal();
  };

  return (
    <Container
      title="Training Management"
      subTitle="List of all trainings
    ">
      <ConfirmationModal
        isOpen={deleteModal}
        onClose={toggleDeleteModal}
        onConfirm={onDeleteConfirm}
        title="Delete Confirmations"
        isLoading={isDeleting}>
        <>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure ?</h4>
            <p className="text-muted ">You want to Remove this Record ?</p>
          </div>
        </>
      </ConfirmationModal>

      <div className="d-flex justify-content-between w-100">
        <PrimaryButton
          title={'Create Training'}
          iconName=" ri-add-line align-bottom me-1"
          onClick={() => navigate('/training-mgmt/training/new')}
          type="button"
        />

        <div className="search-box ms-2">
          <input
            type="text"
            className="form-control search"
            placeholder="Search..."
            name="key"
            value={showQuery}
            onChange={(e) => {
              setShowQuery(e.target.value);
              clearTimeout(timerRef.current);
              timerRef.current = setTimeout(() => {
                setSearchQuery(e.target.value);
              }, 2000);
            }}
          />
          <i className="ri-search-line search-icon" />
        </div>
      </div>

      <TrainingManagementTable
        onAddResourceClicked={(data: any) => {
          setSelectedData(data);

          toggleResourceModal();
        }}
        onEditClicked={onEditClicked}
        onDeleteClicked={onDeleteClicked}
        searchQuery={searchQuery}
      />

      <Modal
        title="Resources"
        isModalOpen={showResourceModal}
        closeModal={toggleResourceModal}
        renderFooter={() => (
          <div className="hstack gap-2 justify-content-end">
            <SecondaryButton onClick={toggleResourceModal} title="Discard" />
          </div>
        )}>
        <ResourcesList selectedData={selectedData} />
      </Modal>
    </Container>
  );
};

export default TrainingManagement;
